import request from '@/utils/request';

// 获取路由
export var getRouters = function getRouters(query) {
  return request({
    url: '/system/user/getRouters',
    method: 'get',
    params: query
  });
};